import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import green from "@material-ui/core/colors/green";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: green,
  },
});

function Datetime(props) {
  let [selectedDate, handleDateChange] = useState(
    props.selectedDate || props.value
  );
  let format = "";

  if (props.datetimeformat == "true") {
    format = "yyyy/MM/dd HH:mm";
  } else {
    format = "dd/MM/yyyy";
  }

  // Support both onChange and handleDateChange prop names
  const onDateChange = props.onChange || props.handleDateChange;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
      <ThemeProvider theme={defaultMaterialTheme}>
        <label>{props.label}</label>
        <DateTimePicker
          format={format}
          value={selectedDate}
          className="form-control"
          onAccept={(event) => onDateChange && onDateChange(event)}
          onChange={handleDateChange}
        ></DateTimePicker>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
}

export default Datetime;
